import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { Filter, FilterItem, FilterQuery } from '../../../services/archive.model';
import { ArchiveService } from '../../../services/archive.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {

  @Input() filter: Filter;

  private filterData: FilterQuery;

  // these are only used on mobile
  // refactor to use same as above
  public values = {
    mood: '-1',
    flavor: '-1',
    location: '-1'
  };

  constructor(private archiveService: ArchiveService) {
    this.filterData = { mood: null, flavor: null, location: null };
    this.archiveService.activeFilter.subscribe(filterQuery => {
        this.filterData = filterQuery;
    });
  }

  public updateFilters(key: 'mood' | 'flavor' | 'location', value: FilterItem): void {
    this.filterData[key] = value;

    this.archiveService.search(this.filterData);
  }

  updateMobileFilters(key: 'mood' | 'flavor' | 'location', $event): void {
    if ($event.target.value === '-1') {
      this.filterData[key] = null;
    } else {
      this.filterData[key] = this.filter[key + 's'].find(v => v.id == $event.target.value);
    }

    this.archiveService.search(this.filterData);
  }

  handleKeyUp($event): void {
    $event.stopPropagation();
  }
}
